import constants from './constants';

const RDC_SECONDS_LEFT_UPDATE = `${constants.NAMESPACE}/LSM_SECONDS_LEFT_UPDATE`;
const SET_SESSION_CLOSED_REASON = `${constants.NAMESPACE}/SET_SESSION_CLOSED_REASON`;

export default {
  RDC_SECONDS_LEFT_UPDATE,
  SET_SESSION_CLOSED_REASON,
};
